import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm text-foreground-600 whitespace-nowrap overflow-x-auto">
      <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">
        <i className="ri-home-4-line"></i>
      </Link>
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2 whitespace-nowrap">
          <i className="ri-arrow-right-s-line text-xs"></i>
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-500 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-950 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}